import { proPolkService } from "../../services/api";

export interface ProPolkData {
  title:       string;
  quoteTop:    string;
  quoteBottom: string;
  photo:       string;
  logo:        string;
  text:        string;
}

const DEFAULT_TEXT = `210-й окремий штурмовий полк створений у серпні 2024 року.
<br /><br /> Нашу військову частину сформовано на основі двох славетних батальйонів...`;

let proPolk: ProPolkData = {
  title:       "",
  quoteTop:    "",
  quoteBottom: "",
  photo:       "",
  logo:        "",
  text:        DEFAULT_TEXT,
};

export async function loadProPolk(): Promise<void> {
  try {
    const response = await proPolkService.get();
    const d = response.data;
    proPolk = {
      title:       d.title       ?? "",
      quoteTop:    d.quoteTop    ?? "",
      quoteBottom: d.quoteBottom ?? "",
      photo:       d.photo       ?? "",
      logo:        d.logo        ?? "",
      text:        d.text        ?? proPolk.text,
    };
  } catch (error) {
    console.error("Failed to load pro polk:", error);
    throw new Error("Не вдалося завантажити контент про полк");
  }
}

export function getProPolk():            ProPolkData { return { ...proPolk }; }
export function getProPolkText():        string      { return proPolk.text; }
export function getProPolkTitle():       string      { return proPolk.title; }
export function getProPolkQuoteTop():    string      { return proPolk.quoteTop; }
export function getProPolkQuoteBottom(): string      { return proPolk.quoteBottom; }
export function getProPolkPhoto():       string      { return proPolk.photo; }
export function getProPolkLogo():        string      { return proPolk.logo; }